import { ButtonHTMLAttributes, FC, ReactNode } from "react";
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import { useNavigate } from "react-router-dom";

interface BackButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
}


function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const BackButton: FC<BackButtonProps> = ({ children, className, ...props }) => {
  const navigate = useNavigate();

  // Check there's a previous page to go back to
  const hasPreviousPage = window.history.length > 1;

  if (!hasPreviousPage) {
    return null;
  }

  // Pull the last thing off the history stack and check it's the same site.
  const lastHistoryEntry = window.history.state;

  const isSameSite = lastHistoryEntry && lastHistoryEntry.key;

  if (!isSameSite) {
    return null;
  }

  return (
    <button onClick={() => navigate(-1)} className={classNames("hidden md:block absolute -ml-8 mt-1 text-2xl")} {...props}>
      {children}
      <ArrowBackTwoToneIcon />
    </button>
  );
};

export default BackButton;
